import styled from "styled-components"

const StyledCheckbox = styled.div`
  .checkbox-label {
    display: block;
    position: relative;
    padding-left: 0;
    padding-top: 5px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .checkbox-label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    right: 0;
    height: 25px;
    width: 25px;
    background-color: var(--color-background);
    border: solid 2px var(--color-lineColor);
    border-radius: 4px;
  }
  .checkbox-label input:checked ~ .checkmark {
    border: 0 !important;
    background-color: var(--color-ebateCheckboxActive);
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-label input:checked ~ .checkmark:after {
    display: block;
  }
  .checkbox-label .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .indeterminate {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fff;
    border: solid 2px #919191;
    border-radius: 4px;
  }
  .checkbox-label input ~ .indeterminate {
    border: 0 !important;
    background-color: #d87451;
  }
  .indeterminate:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-label input ~ .indeterminate:after {
    display: block;
  }
  .checkbox-label .indeterminate:after {
    left: 6px;
    top: 11px;
    width: 10px;
    height: 0;
    border: solid white;
    border-width: 0 3px 3px 0;
  }
`

export default StyledCheckbox
